import { render } from "./CopyGroup.vue?vue&type=template&id=e006b00a"
import script from "./CopyGroup.vue?vue&type=script&lang=js"
export * from "./CopyGroup.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__